import React, { useState } from 'react';
import { useAdminMode } from '../../hooks/useAdminMode';
import { useAuth } from '../../contexts/AuthContext';
import Sidebar from './SidebarNew';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const MainLayout = ({ children }) => {
  const { isImpersonating, exitImpersonation } = useAdminMode();
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <div className="min-h-screen flex">
      {/* Sidebar for mobile */}
      <div className={`fixed inset-y-0 right-0 z-40 w-64 transition-transform duration-300 ease-in-out transform ${sidebarOpen ? 'translate-x-0' : 'translate-x-full'} md:hidden`}>
        <div className="h-full bg-blue-800 shadow-xl">
          <div className="flex justify-between items-center p-4 bg-blue-900">
            <button
              type="button"
              className="text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
              onClick={toggleSidebar}
            >
              <span className="sr-only">بستن منو</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <h1 className="text-xl font-bold text-white">ادمین هوشمند</h1>
          </div>
          <Sidebar closeSidebar={() => setSidebarOpen(false)} />
        </div>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 z-30 md:hidden" onClick={toggleSidebar}></div>
      )}

      {/* Static sidebar for desktop - fixed */}
      <div className="hidden md:flex md:flex-shrink-0">
        <div
          className="flex flex-col w-64 h-screen fixed right-0 top-0"
          style={{ position: 'fixed', right: 0, top: 0, height: '100vh', overflowY: 'hidden' }}
        >
          <Sidebar />
        </div>
      </div>

      {/* Spacer for fixed sidebar */}
      <div className="hidden md:block md:w-64 md:flex-shrink-0"></div>

      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Admin impersonation banner */}
        {isImpersonating && (
          <div className="bg-purple-100 border-b border-purple-500 sticky top-0 z-50">
            <div className="container mx-auto px-4 py-2">
              <div className="flex justify-between items-center">
                <div className="flex items-center space-x-4 space-x-reverse">
                  <span className="text-purple-700">
                    <span className="font-medium">حالت مدیریت:</span> شما در حال مشاهده به عنوان{' '}
                    <span className="font-bold">{user?.username}</span> هستید
                  </span>
                </div>
                <div className="flex items-center space-x-2 space-x-reverse">
                  <button
                    onClick={exitImpersonation}
                    className="px-3 py-1 bg-purple-200 hover:bg-purple-300 text-purple-800 rounded-md text-sm transition-colors duration-200"
                  >
                    بازگشت به اکانت اصلی
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Mobile header - فقط دکمه منو */}
        <header className="bg-white dark:bg-slate-900 shadow-sm md:hidden sticky top-0 z-10 border-b dark:border-slate-700">
          <div className="px-4 py-4 flex items-center justify-between">
            <button
              type="button"
              className="p-2 rounded-md text-gray-600 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-slate-800"
              onClick={toggleSidebar}
            >
              <Bars3Icon className="h-6 w-6" />
            </button>
            <h1 className="text-lg font-semibold text-gray-900 dark:text-white">رقیب‌سنج</h1>
            <div className="w-10"></div> {/* Spacer */}
          </div>
        </header>

        {/* Main content area */}
        <main className="flex-1 relative overflow-y-auto focus:outline-none">
          <div className="py-4">
            <div className="mx-auto px-2 sm:px-3 md:px-4">
              {children}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout; 